// extracted by mini-css-extract-plugin
export default {"container":"LoaderPage_container__qj0Gu"};